import { Container, Flex, Box, Image, Text } from '@chakra-ui/react'
import { PospImages } from 'Assets/Posp'
import { BsFillTelephoneFill } from 'react-icons/bs'
import { IoIosMail } from 'react-icons/io'

const PospFooter = () => (
  <footer>
    <Box mt='4' fontSize='sm' color='white' bg='#001d4c'>
      <Container maxW='1300px'>
        <Flex justifyContent='space-between' p={5} flexWrap='wrap' borderBottom='2px solid white'>
          <Box>
            <Image width='200px' src={PospImages.ZopperWhiteLogo} mb={2} />
            <Text>Zopper Insurance Brokers Private Limited</Text>
            <Text>(CIN no U66000DL2020PTC373851)</Text>
          </Box>
          <Box>
            <Text fontWeight='semibold' pb='4'>
              REGISTERED OFFICE ADDRESS
            </Text>
            <Text>293 S/F Western Marg,</Text>
            <Text>Saidulajab Near Kher Singh Estate,</Text>
            <Text>Saket, New Delhi - 110030</Text>
            {/* <Text>101, Pratap Nagar, Mayur Vihar,</Text>
            <Text>Phase 1, New Delhi - 110091</Text> */}
          </Box>
          <Box>
            <Text fontWeight='semibold' pb='4'>
              CORPORATE OFFICE ADDRESS
            </Text>
            {/* <Text>293 S/F Western Marg,</Text>
            <Text>Saidulajab Near Kher Singh Estate,</Text>
            <Text>Saket, New Delhi - 110030</Text> */}
            <Text>7th Floor, Plot no 1, BGR Tower,</Text>
            <Text>Sector 16 A, NOIDA U.P. 201301</Text>
          </Box>
          <Box>
            <Text fontWeight='semibold' pb='4'>
              CONTACT US
            </Text>
            <Flex gap='2'>
              <IoIosMail size='20px' />
              {/* pos@zopperinsurance.com */}
              no-reply@zopperinsurance.com
            </Flex>
            <Flex gap='2'>
              <BsFillTelephoneFill size='20px' />
              {/* +91 7272803803 */}
              1800-313-245245
            </Flex>
          </Box>
        </Flex>
        <Text align='center' w='full' py='4'>
          IRDAI Licence no 790. Direct Broker (Life & General) valid till 23rd December 2027
        </Text>
      </Container>
    </Box>
  </footer>
)

export default PospFooter
